import React, { useEffect, useRef, useState } from 'react'

import { Checkbox } from 'antd'
import { useDispatch } from 'react-redux'
import Pagination from '../../../../components/Pagination'
import TableSearchFilter from '../../../../components/UIComponents/TableSearchFilter'
import {
  setIsRuleEdited,
  setSelectedDegreesAndDepartmentsList,
} from '../../action'
import { SectionWrapper, TopFlex, TopHeader } from '../../Style/style'
import { DepartmentTableDiv, StyledTableNew } from '../Dashboard/style'
import RuleHeader from '../RuleHeader'

const YetToSetRulesTable = ({
  setUpNewRules,
  rulesDegreesMetrics,
  degreeStreamMap,
  ruleDegreeStreamMap,
  createRules,
  ruleOverwrite,
  getInstituteRulesById,
  ruleSet,
}) => {
  const [selectedKeys, setSelectedKeys] = useState([])
  const [selectAllChecked, setSelectAllChecked] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [paginationCount, setPaginationCount] = useState(1)
  const [searchValue, setSearchValue] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const object = useRef()
  const dispatch = useDispatch()
  const handleSelectAll = checked => {
    setSelectAllChecked(checked)
    setSelectedKeys(rulesDegreesMetrics?.yetToSetDegreeStreamMap || [])
    if (!checked) setSelectedKeys([])
  }
  const onRowSelectChange = (value, checked) => {
    let updatedSelectedKeys = []
    if (checked) {
      updatedSelectedKeys = [...selectedKeys, value]
    } else {
      updatedSelectedKeys = selectedKeys.filter(item => item !== value)
    }
    setSelectedKeys(updatedSelectedKeys)
    if (
      updatedSelectedKeys.length ===
      rulesDegreesMetrics?.yetToSetDegreeStreamMap.length
    ) {
      setSelectAllChecked(true)
    } else {
      setSelectAllChecked(false)
    }
  }

  const columns = [
    {
      title: (
        <Checkbox
          checked={selectAllChecked}
          indeterminate={selectedKeys.length > 0 && !selectAllChecked}
          onChange={e => handleSelectAll(e.target.checked)}
        />
      ),
      dataIndex: 'select',
      key: 'select',
      align: 'center',
      width: '80px',
      render: (text, record) => (
        <Checkbox
          checked={selectedKeys.includes(record.id)}
          onChange={e => onRowSelectChange(record.id, e.target.checked)}
        />
      ),
    },
    {
      title: 'Degree & Department',
      dataIndex: 'DegreeDepartment',
      key: 'Degree & Department',
      align: 'left',
      render: (text, record) => <div>{text}</div>,
    },
  ]
  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }

  const handleDegreeRender = ({
    page: paginationCount,
    search: searchDebounce,
  }) => {
    setIsLoading(true)

    degreeStreamMap({
      degreeStreamMapIds:
        rulesDegreesMetrics?.yetToSetDegreeStreamMap?.join(',') || '',
      page: paginationCount || 1,
      search: searchDebounce || '',
    })

    setTimeout(() => {
      setIsLoading(false)
    }, 500)
  }

  useEffect(() => {
    if (rulesDegreesMetrics?.length === 0) {
      setUpNewRules()
    }
    handleDegreeRender({})
  }, [rulesDegreesMetrics])

  useEffect(() => {
    if (ruleDegreeStreamMap?.result?.length) {
      const newDataSource = ruleDegreeStreamMap.result.map((item, index) => ({
        ...item,
        key: index + 1,
        DegreeDepartment:
          (item?.degree?.shortForm || item?.degree?.name || '') +
          ' - ' +
          (item?.stream?.name || item?.stream?.shortForm || ''),
      }))
      const data = {
        data: ruleDegreeStreamMap,
        tableData: newDataSource,
      }
      setDataSource(data)
    } else {
      setDataSource([])
    }
  }, [ruleDegreeStreamMap])

  const pageChange = (pagination, filter, sorter) => {
    setPaginationCount(pagination)
    handleDegreeRender({ page: pagination, search: searchValue })
    setIsLoading(true)
    ScrollRef()
    setTimeout(() => {
      setIsLoading(false)
    }, 500)
  }

  const handleSearch = e => {
    setSearchValue(e.target.value)
  }

  React.useEffect(() => {
    if (searchValue !== null) {
      setIsLoading(true)
      const timeout = setTimeout(() => {
        setPaginationCount(1)
        handleDegreeRender({ page: 1, search: searchValue })
      }, 1000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [searchValue])

  useEffect(() => {
    dispatch(
      setSelectedDegreesAndDepartmentsList({
        check: false,
        list: [],
      })
    )
    dispatch(setIsRuleEdited(false))
  }, [])

  return (
    <SectionWrapper>
      <div ref={object}></div>
      <TopHeader row spaceBetween alignCenter>
        <TopFlex column>
          <RuleHeader
            cardData={rulesDegreesMetrics}
            degreeStreamMapList={selectedKeys}
            createRules={createRules}
            getInstituteRulesById={getInstituteRulesById}
            ruleOverwrite={ruleOverwrite}
            isDraftRuleExist={ruleSet?.isDraftRuleExist}
          />
          <DepartmentTableDiv>
            <TableSearchFilter
              rulesDegreesMetrics={rulesDegreesMetrics}
              setSearchValue={setSearchValue}
              searchValue={searchValue}
              handleSearch={handleSearch}
              paginationCount={paginationCount}
              setPaginationCount={setPaginationCount}
              hideFilter={true}
              customTableHeight={'55px'}
              ruleEngine={true}
              padding={'0px 20px'}
              totalCount={dataSource?.data?.count}
              currentCount={
                (paginationCount - 1) * 10 + dataSource?.tableData?.length
              }
            />
            <StyledTableNew
              loading={isLoading}
              columns={columns}
              dataSource={dataSource.tableData}
              pagination={false}
              rowKey={record => record.id}
            />
            <Pagination
              width={'95%'}
              pageSize={10}
              totalPages={dataSource?.data?.count}
              current={paginationCount}
              onChange={pageChange}
            />
          </DepartmentTableDiv>
        </TopFlex>
      </TopHeader>
    </SectionWrapper>
  )
}

export default YetToSetRulesTable
